import React, { useState, useEffect } from "react";
import * as ReactDOM from "react-dom";
import "./Banner.css";
import useAppContext from "../../context/Context";
import Modal from "../Modal/Modal";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles

const Banner = () => {
  const { activeCountry } = useAppContext();
  const [open, setOpen] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [text, setText] = useState("");

  useEffect(() => {
    if (window.screen.width <= 768) {
      setText("Agenda una reunión con nosotros");
    } else {
      setText("Agenda una reunión con nosotros para conocer más sobre ETpay");
    }
  }, []);

  const changeBanner = () => {
    setOpen(false);
    if (document.getElementById("containerMenuStickyWithBanner")) {
      var element = document.getElementById("containerMenuStickyWithBanner");
      element.classList.remove("containerMenuStickyWithBanner");
    }
  };

  const changeModal = () => {
    setOpenModal(!openModal);
  };

  useEffect(() => {
    AOS.init({
      // Global settings:
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
      initClassName: "aos-init", // class applied after initialization
      animatedClassName: "aos-animate", // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
      disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 400, // values from 0 to 3000, with step 50ms
      easing: "ease", // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  }, []);

  return (
    <>
      {openModal === true &&
        ReactDOM.createPortal(
          <Modal
            changeModal={changeModal}
            content={
              <iframe
                title="new-hubspot-meeting"
                className="iframe"
                src={
                  activeCountry === "mx"
                    ? "https://meetings.hubspot.com/wandi"
                    : "https://meetings.hubspot.com/barbara-bustos"
                }
                frameborder="0"
              ></iframe>
            }
          ></Modal>,
          document.getElementById("portal")
        )}

      {/* {open && activeCountry !== "mx" ? ( */}
      {open && (
        <div
          className="banner-modal"
          data-aos="fade-down"
          style={{
            padding: "1rem 0.5rem 1rem 0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "30px",
            position: "sticky",
            top: "0",
            width: "100%",
            height: "auto",
          }}
        >
          <span
            className="title-banner"
            style={{ color: "#140F33", fontSize: "16px" }}
          >
            {text}
          </span>
          <button
            onClick={() => setOpenModal(!openModal)}
            className="button-demo"
            target={"_blank"}
            style={{
              cursor: "pointer",
              border: "none",
              background: "#72DBAA",
              width: "141px",
              height: "40px",
              borderRadius: "12px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {activeCountry === "mx" ? "Programar Demo" : "Solicitar Demo"}
          </button>
          <button
            className="cross"
            onClick={changeBanner}
            style={{
              border: "none",
              background: "none",
              cursor: "pointer",
              float: "right",
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17 7L7 17"
                stroke="#646174"
                strokeWidth="1.5"
                strokeLinecap="square"
                strokeLinejoin="round"
              />
              <path
                d="M7 7L17 17"
                stroke="#646174"
                strokeWidth="1.5"
                strokeLinecap="square"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      )}
      {/* ) : (
        <></>
      )} */}
    </>
  );
};

export default Banner;
